const doc = [({"ko":({"adminConstantHotelChildrenSearchDisplayType":({"all":"모두", "onlyAge":"연령만 표시", "onlyMealTypeAndBedding":"식사/침구만 표시"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;